import { Injectable } from '@angular/core'; 
import { Agent, Kasa, UserProfile } from './web-api-client';

let inMemoryStorage: object = {};

@Injectable({
  providedIn: 'root',
})
export class WtStorageService {
  private isNativePlatform: boolean=false;
  private userCacheKey:string='userKey';
  private kasaCacheKey:string='kasaKey';
  private agentCacheKey:string='agentKey';

  constructor() {

  }

  getАgent(): Agent {

    let item = this.getItem(this.agentCacheKey);
    if (item) {
      return JSON.parse(item);
    }

    return null;
  }

  setАgent(user: Agent) {
    this.setItem(this.agentCacheKey, JSON.stringify(user));
  }

  removeАgent() {
    this.removeItem(this.agentCacheKey);

  }

  getkasa(): Kasa {

    let item = this.getItem(this.kasaCacheKey);
    if (item) {
      return JSON.parse(item);
    }

    return null;
  }

  setkasa(user: Kasa) {
    this.setItem(this.kasaCacheKey, JSON.stringify(user));
  }

  removekasa() {
    this.removeItem(this.kasaCacheKey);
  }

  getuser():UserProfile{

    let item = this.getItem(this.userCacheKey);
    if(item){
      return JSON.parse(item);
    }

    return null;
  }

  setuser(user:UserProfile){
    this.setItem(this.userCacheKey,JSON.stringify(user));
  }

  removeuser(){
    this.removeItem(this.userCacheKey);
  }


  getItem(key: string): string | null {
    if (this.isNativePlatform) {
      return inMemoryStorage[key];
    } else {
      return localStorage.getItem(key);
    }
  }

  removeItem(key: string): void {
    if (this.isNativePlatform) {
      delete inMemoryStorage[key];
    } else {
      localStorage.removeItem(key);
    }
  }

  setItem(key: string, data: string): void {
    if (this.isNativePlatform) {
      inMemoryStorage[key] = data;
    } else {
      localStorage.setItem(key, data);
    }
  }

  clear(): void {
    if (this.isNativePlatform) {
      inMemoryStorage = {};
    }
    const dashboardLayout = JSON.parse(localStorage.getItem('dashboardLayout'));
    localStorage.clear();
    if (dashboardLayout) {
      localStorage.setItem('dashboardLayout', JSON.stringify(dashboardLayout));
    }
  }

}
